import { combineReducers } from '@reduxjs/toolkit';
import templateReducer from './services/templateSlice';
import uploadReducer from './services/uploadSlice';
import homeReducer from './services/homeSlice';
import searchReducer from './services/searchSlice';

const appReducer = combineReducers({
  template: templateReducer,
  upload: uploadReducer,
  home: homeReducer,
  search: searchReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
